import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createModal } from 'react-modal-promise';
import { bindActionCreators } from 'redux';
import '../ReactModal/reactModal.scss';
import penActions from '../../redux/pen/actions';
import './ProtectionPlansPen.scss';

function HideProductPriceChallenge(props) {
  const { actions, dealer, close, enabledPenProducts, pen } = props;

  const handleSubmit = () => {
    const products = enabledPenProducts.map(p => {
      const formData = new FormData();
      p.enabled = false;
      formData.append('product', JSON.stringify(p));
      return { formData, productId: p.id };
    });
    actions.disableProductsRequest({
      dealerId: dealer.id,
      products,
    });
    close(true);
  };

  const handleClose = () => {
    // close without saving
    close(false);
  };

  return (
    <div className="p-modal-container">
      <div className="p-modal large">
        <div className="p-modal-text">
          <h2>Hide Product Prices?</h2>
        </div>
        <i
          onClick={() => close(false)}
          className="modal-close close icon"
          alt="close"
        />
        {pen.error && (
          <div className="p-modal-body p-modal-body-column error-container ">
            <p>Could not disable Products. An Error Occurred.</p>
            <p>{pen.error.error}</p>
          </div>
        )}
        {!pen.error && (
          <div className="p-modal-body p-modal-body-column">
            <p>
              Hiding Product Prices will limit available product offerings. Are
              you sure you want to disable the following{' '}
              {enabledPenProducts.length} PEN Products?
            </p>
            <div className="product-names-container">
              <ul>
                {enabledPenProducts.map(p => (
                  <li>
                    {p.displayName} - {p.raw.name}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        )}
        {pen.error && (
          <div className="p-modal-actions product-actions">
            <button
              className="btn btn-default btn-large"
              onClick={() => handleClose()}
            >
              OK
            </button>
          </div>
        )}
        {!pen.error && (
          <div className="p-modal-actions product-actions">
            <button
              className="btn btn-default btn-large"
              onClick={() => handleClose()}
            >
              Cancel
            </button>
            <button
              className="btn btn-primary btn-large btn-large-default"
              onClick={e => handleSubmit(e)}
            >
              Disable Products
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

HideProductPriceChallenge.propTypes = {
  close: PropTypes.func,
  enabledPenProducts: PropTypes.object,
  actions: PropTypes.object,
  dealer: PropTypes.object,
  pen: PropTypes.object,
};

const mapStateToProps = ({ pen }) => ({
  pen,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      ...penActions,
    },
    dispatch,
  ),
});

const HideProductPriceChallengeModal = createModal(
  connect(mapStateToProps, mapDispatchToProps)(HideProductPriceChallenge),
);

export default HideProductPriceChallengeModal;
